// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__xbfV3","boxTitle":"Qualiphy_boxTitle__2bgsn","box":"Qualiphy_box__2AKyI","toggleWrap":"Qualiphy_toggleWrap__oxnko"};